import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can use access tokens to test private npm packages with continuous integration (CI) systems, or deploy them using continuous deployment (CD) systems.`}</p>
    <h2>{`Create a new access token`}</h2>
    <p>{`Create a new access token that will be used only to access npm packages from a CI/CD server.`}</p>
    <h3>{`Continuous integration`}</h3>
    <p>{`By default, `}<inlineCode parentName="p">{`npm token create`}</inlineCode>{` will generate a token with both read and write permissions. When generating a token for use in a continuous integration environment, we recommend creating a read-only token:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm token create --read-only
`}</code></pre>
    <p>{`For more information on creating access tokens, including CIDR-whitelisted tokens, see "`}<a parentName="p" {...{
        "href": "creating-and-viewing-access-tokens"
      }}>{`Creating an access token`}</a>{`".`}</p>
    <h3>{`Continuous deployment`}</h3>
    <p>{`Since continuous deployment environments usually involve the creation of a deploy artifact, you may wish to create an `}<a parentName="p" {...{
        "href": "creating-and-viewing-access-tokens"
      }}>{`automation token`}</a>{` on the website. This will allow you to publish even if you have two-factor authentication enabled on your account.`}</p>
    <h3>{`Interactive workflows`}</h3>
    <p>{`If your workflow produces a package, but you publish it manually after validation, then you will want to create a token with read and write permissions, which are granted with the standard token creation command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm token create
`}</code></pre>
    <h3>{`CIDR whitelists`}</h3>
    <p>{`For increased security, you may use a CIDR-whitelisted token that can only be used from a certain IP address range. You can use a CIDR whitelist with a read and publish token or a read-only token:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm token create --cidr=[list]
npm token create --read-only --cidr=[list]
`}</code></pre>
    <p>{`Example:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm token create --cidr=192.0.2.0/24
`}</code></pre>
    <p>{`For more information, see "`}<a parentName="p" {...{
        "href": "creating-and-viewing-access-tokens"
      }}>{`Creating and viewing authentication tokens`}</a>{`".`}</p>
    <h2>{`Set the token as an environment variable on the CI/CD server`}</h2>
    <p>{`Set your token as an environment variable, or a secret, in your CI/CD server.`}</p>
    <p>{`For example, in GitHub Actions, you would `}<a parentName="p" {...{
        "href": "https://docs.github.com/en/actions/configuring-and-managing-workflows/creating-and-storing-encrypted-secrets"
      }}>{`add your token as a secret`}</a>{`. Then you can make the secret available to workflows.`}</p>
    <p>{`If you named the secret `}<inlineCode parentName="p">{`NPM_TOKEN`}</inlineCode>{`, then you would want to create an environment variable named `}<inlineCode parentName="p">{`NPM_TOKEN`}</inlineCode>{` from that secret.`}</p>
    <pre><code parentName="pre" {...{}}>{`steps:
  - run: |
      npm install
  - env:
      NPM_TOKEN: \${{ secrets.NPM_TOKEN }}
`}</code></pre>
    <p>{`Consult your CI/CD server's documentation for more details.`}</p>
    <h2>{`Create and check in a project-specific .npmrc file`}</h2>
    <p>{`Use a project-specific `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` file with a variable for your token to securely authenticate your CI/CD server with npm.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In the root directory of your project, create a custom `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` file with the following contents:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`//registry.npmjs.org/:_authToken=\${NPM_TOKEN}
`}</code></pre>
        <p parentName="li"><strong parentName="p">{`Note:`}</strong>{` that you are specifying a literal value of `}<inlineCode parentName="p">{`\${NPM_TOKEN}`}</inlineCode>{`. The npm cli will replace this value with the contents of the `}<inlineCode parentName="p">{`NPM_TOKEN`}</inlineCode>{` environment variable. Do `}<strong parentName="p">{`not`}</strong>{` put a token in this file.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Check in the `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` file.`}</p>
      </li>
    </ol>
    <h2>{`Securing your token`}</h2>
    <p>{`Your token may have permission to read private packages, publish new packages on your behalf, or change user or package settings. Protect your token.`}</p>
    <p>{`Do not add your token to version control or store it insecurely. Store it in a password manager, your cloud provider's secure storage, or your CI/CD provider's secure storage.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      